import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/blocks.action'

import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import I18n from 'i18n'
import { editBlocksOrder } from 'api/administration/blocks/Edit'

async function handleEditBlocksOrder(lessonId: number, blocks: number[]) {
  return await editBlocksOrder(lessonId, blocks)
}

function* editBlocksOrderEffectSaga({ payload: { lessonId, blocks } }: any) {
  try {
    yield call(handleEditBlocksOrder, lessonId, blocks)
  } catch (error) {
    yield put(fromActions.Actions.setLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.editError'))
    console.log('error: ', error)
  }
}

export function* editBlocksOrderWatcherSaga() {
  yield takeLatest(fromActions.BLOCK_ORDER_EDIT, editBlocksOrderEffectSaga)
}
